// src/screens/AdditionalInput.js
import { analyzeConcrete } from '../services/claude.js';

const PERC_OPTS = [
  { id: 'hollow',   label: 'Sí — sonido hueco claramente' },
  { id: 'partial',  label: 'Parcialmente — algunas zonas huecas' },
  { id: 'solid',    label: 'No — sonido sólido' },
  { id: 'not_done', label: 'No realicé la prueba' },
];

const PH_OPTS = [
  { id: 'pheno_0_5',    label: 'Fenolftaleína: 0–5 mm' },
  { id: 'pheno_5_15',   label: 'Fenolftaleína: 5–15 mm' },
  { id: 'pheno_15_30',  label: 'Fenolftaleína: 15–30 mm' },
  { id: 'pheno_over30', label: 'Fenolftaleína: >30 mm (llegó a armadura)' },
  { id: 'ph_7_9',       label: 'pH: 7–9 (carbonatación parcial)' },
  { id: 'ph_below_7',   label: 'pH: <7 (carbonatación avanzada)' },
  { id: 'no_test',      label: 'Sin aditamento — solo análisis visual' },
];

export function AdditionalInputScreen(container, state, actions) {
  const isDelam = state.diagnosis?.pathology_id === 'p03_delamination';
  const opts    = isDelam ? PERC_OPTS : PH_OPTS;
  const sel     = state.additionalInput || '';

  container.innerHTML = `
    <div class="screen">
      <div class="top-bar">
        <div class="logo">
          <div class="logo-sq"><i class="ti ti-building-factory-2" aria-hidden="true"></i></div>
          <div><div class="logo-name">CONCREPRO</div></div>
        </div>
      </div>
      <div class="screen-body">
        <button class="btn-back" id="btn-back"><i class="ti ti-arrow-left" aria-hidden="true"></i> Volver</button>
        <h2 style="font-size:20px;font-weight:500;margin:0 0 4px">Información adicional</h2>
        <p style="font-size:13px;color:var(--dim);margin:0 0 14px">
          ${isDelam ? 'Prueba de percusión (ICRI 210.1R)' : 'Medición pH / Fenolftaleína (EN 1504-9)'}
        </p>
        <div class="card" style="margin-bottom:14px">
          <div class="card-label">${isDelam ? 'Prueba de cadena / varilla' : 'Fenolftaleína 1% o medidor pH'}</div>
          <div style="font-size:12px;color:var(--dim);margin-bottom:14px;line-height:1.5">
            ${isDelam
              ? 'Arrastra cadena metálica sobre la losa. Sonido hueco confirma delaminación activa.'
              : 'Rompe muestra fresca, aplica fenolftaleína al 1%. Zona incolora = carbonatada.'}
          </div>
          <div role="radiogroup" aria-label="Resultado de la prueba de campo">
            ${opts.map(o => `
              <button class="option-btn${sel === o.id ? ' selected' : ''}"
                      data-id="${o.id}" role="radio" aria-checked="${sel === o.id}">
                <i class="ti ${sel === o.id ? 'ti-circle-check' : 'ti-circle'}" aria-hidden="true"
                   style="font-size:15px;color:${sel === o.id ? 'var(--amber)' : 'var(--muted)'}"></i>
                ${o.label}
              </button>`).join('')}
          </div>
        </div>
        <button id="btn-complete" class="btn-primary" ${!sel ? 'disabled' : ''}>
          <i class="ti ti-microscope" aria-hidden="true"></i> Completar diagnóstico
        </button>
      </div>
    </div>`;

  container.querySelector('#btn-back')?.addEventListener('click', () => {
    actions.navigate('capture', { additionalInput: '' });
  });

  container.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', () => actions.setState({ additionalInput: btn.dataset.id }));
  });

  container.querySelector('#btn-complete')?.addEventListener('click', async () => {
    if (!sel) return;
    const selectedLabel = opts.find(o => o.id === sel)?.label || sel;
    actions.navigate('analyzing', { loadMsgIndex: 0 });
    actions.startLoadingCycle(5);
    try {
      const diagnosis = await analyzeConcrete(
        state.image.base64,
        state.diagnosis?.pathology_id || 'auto',
        selectedLabel
      );
      actions.stopLoadingCycle();
      actions.navigate('result', { diagnosis, additionalInput: '' });
    } catch (e) {
      actions.stopLoadingCycle();
      actions.navigate('capture', { error: 'Error: ' + (e.message || 'Intenta de nuevo.'), additionalInput: '' });
    }
  });
}
